(function(){
  'use strict';

  var root=document.querySelector('[data-nn-privacy]');
  if(!root)return;

  var notice=root.querySelector('[data-nn-privacy-notice]');
  var modal=root.querySelector('[data-nn-privacy-modal]');
  var panel=root.querySelector('[data-nn-privacy-panel]');
  var analyticsInput=root.querySelector('[data-nn-privacy-analytics]');
  var preferencesInput=root.querySelector('[data-nn-privacy-preferences]');
  var marketingInput=root.querySelector('[data-nn-privacy-marketing]');
  var saleSection=root.querySelector('[data-nn-privacy-sale]');
  var saleButton=root.querySelector('[data-nn-privacy-sale-opt-out]');
  var saleStatus=root.querySelector('[data-nn-privacy-sale-status]');
  var preview=new URLSearchParams(window.location.search).get('nn_privacy_preview')==='1';
  var privacyApi=null;
  var returnToNotice=false;
  var previousFocus=null;

  function all(selector){return Array.prototype.slice.call(root.querySelectorAll(selector));}
  function focusable(container){return Array.prototype.slice.call(container.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]'));}

  function setErrors(message){
    all('[data-nn-privacy-error]').forEach(function(error){
      error.textContent=message||'';
      error.hidden=!message;
    });
  }

  function setBusy(busy){
    all('[data-nn-privacy-accept],[data-nn-privacy-reject],[data-nn-privacy-save],[data-nn-privacy-sale-opt-out]').forEach(function(button){button.disabled=busy;});
    root.setAttribute('aria-busy',busy?'true':'false');
  }

  function consentFailed(value){
    if(!value)return false;
    if(typeof value==='string')return true;
    if(value instanceof Error)return true;
    if(typeof value!=='object')return false;
    if(value.error)return true;
    if(value.statusCode&&Number(value.statusCode)>=400)return true;
    return value.name==='Error';
  }

  function effectiveConsent(explicitValue,methodName){
    if(explicitValue==='yes')return true;
    if(explicitValue==='no')return false;
    if(privacyApi&&typeof privacyApi[methodName]==='function'){
      try{return Boolean(privacyApi[methodName]());}catch(error){return false;}
    }
    return false;
  }

  function showNotice(){
    setErrors('');
    root.hidden=false;
    notice.hidden=false;
    modal.hidden=true;
    document.body.classList.remove('nn-privacy-modal-open');
  }

  function hideAll(){
    root.hidden=true;
    notice.hidden=false;
    modal.hidden=true;
    document.body.classList.remove('nn-privacy-modal-open');
    if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
    previousFocus=null;
  }

  function syncInputs(){
    if(!privacyApi||typeof privacyApi.currentVisitorConsent!=='function')return;
    try{
      var consent=privacyApi.currentVisitorConsent()||{};
      analyticsInput.checked=effectiveConsent(consent.analytics,'analyticsProcessingAllowed');
      preferencesInput.checked=effectiveConsent(consent.preferences,'preferencesProcessingAllowed');
      marketingInput.checked=effectiveConsent(consent.marketing,'marketingAllowed');
    }catch(error){
      analyticsInput.checked=false;
      preferencesInput.checked=false;
      marketingInput.checked=false;
    }
  }

  function configureSaleControl(customerInitiated){
    var eligible=false;
    if(customerInitiated){
      if(preview)eligible=true;
      else if(privacyApi&&typeof privacyApi.saleOfDataRegion==='function'){
        try{eligible=Boolean(privacyApi.saleOfDataRegion());}catch(error){eligible=false;}
      }
    }

    saleSection.hidden=!eligible;
    saleStatus.hidden=true;
    saleStatus.textContent='';
    saleButton.disabled=false;
    saleButton.textContent='Do not sell or share my information';
    if(!eligible||!privacyApi||typeof privacyApi.currentVisitorConsent!=='function')return;

    try{
      var consent=privacyApi.currentVisitorConsent()||{};
      if(consent.sale_of_data==='no'){
        saleButton.disabled=true;
        saleButton.textContent='Opt-out saved';
        saleStatus.textContent='Your data sale and sharing opt-out is active.';
        saleStatus.hidden=false;
      }
    }catch(error){
      saleButton.disabled=false;
    }
  }

  function openPreferences(fromNotice){
    setErrors('');
    previousFocus=document.activeElement;
    returnToNotice=Boolean(fromNotice);
    syncInputs();
    configureSaleControl(!fromNotice);
    root.hidden=false;
    notice.hidden=true;
    modal.hidden=false;
    document.body.classList.add('nn-privacy-modal-open');
    window.requestAnimationFrame(function(){
      var first=focusable(panel)[0];
      if(first)first.focus();
      else panel.focus();
    });
  }

  function closePreferences(){
    modal.hidden=true;
    document.body.classList.remove('nn-privacy-modal-open');
    if(returnToNotice){
      notice.hidden=false;
      if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
    }else{
      root.hidden=true;
      if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
    }
    previousFocus=null;
  }

  function sendConsent(values,onSuccess,failureMessage){
    setBusy(true);
    var finished=false;
    var timeoutId=window.setTimeout(function(){
      if(finished)return;
      finished=true;
      setBusy(false);
      setErrors(failureMessage);
    },8000);

    function complete(resultOrError){
      if(finished)return;
      finished=true;
      window.clearTimeout(timeoutId);
      setBusy(false);
      if(consentFailed(resultOrError)){
        setErrors(failureMessage);
        return;
      }
      onSuccess();
    }

    try{privacyApi.setTrackingConsent(values,complete);}
    catch(error){complete(error);}
  }

  function submitConsent(values){
    setErrors('');
    if(preview){
      hideAll();
      return;
    }
    if(!privacyApi||typeof privacyApi.setTrackingConsent!=='function'){
      setErrors('We could not load privacy controls. Please try again.');
      return;
    }
    sendConsent(values,function(){
      try{window.dispatchEvent(new CustomEvent('nn:privacy_consent',{detail:values}));}catch(error){}
      hideAll();
    },'We could not save your choice. Please try again.');
  }

  function optOutOfSale(){
    setErrors('');
    if(preview){
      saleButton.disabled=true;
      saleButton.textContent='Opt-out saved';
      saleStatus.textContent='Preview only. No privacy preference was changed.';
      saleStatus.hidden=false;
      return;
    }
    if(!privacyApi||typeof privacyApi.setTrackingConsent!=='function'){
      setErrors('We could not load privacy controls. Please try again.');
      return;
    }

    sendConsent({sale_of_data:false},function(){
      saleButton.disabled=true;
      saleButton.textContent='Opt-out saved';
      saleStatus.textContent='Your data sale and sharing opt-out is active.';
      saleStatus.hidden=false;
    },'We could not save your opt-out. Please try again.');
  }

  function acceptAll(){submitConsent({analytics:true,preferences:true,marketing:true});}
  function rejectAll(){submitConsent({analytics:false,preferences:false,marketing:false});}
  function saveChoices(){submitConsent({analytics:analyticsInput.checked,preferences:preferencesInput.checked,marketing:marketingInput.checked});}

  all('[data-nn-privacy-accept]').forEach(function(button){button.addEventListener('click',acceptAll);});
  all('[data-nn-privacy-reject]').forEach(function(button){button.addEventListener('click',rejectAll);});
  all('[data-nn-privacy-save]').forEach(function(button){button.addEventListener('click',saveChoices);});
  saleButton.addEventListener('click',optOutOfSale);
  all('[data-nn-privacy-close]').forEach(function(button){button.addEventListener('click',closePreferences);});
  all('[data-nn-privacy-manage]').forEach(function(button){button.addEventListener('click',function(){openPreferences(true);});});

  panel.addEventListener('keydown',function(event){
    if(event.key==='Escape'){
      event.preventDefault();
      closePreferences();
      return;
    }
    if(event.key!=='Tab')return;
    var items=focusable(panel);
    if(!items.length)return;
    var first=items[0];
    var last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });

  document.addEventListener('click',function(event){
    var trigger=event.target.closest('[data-nn-privacy-open]');
    if(!trigger||!document.documentElement.classList.contains('nn-custom-privacy-ready'))return;
    event.preventDefault();
    event.stopPropagation();
    openPreferences(false);
  },true);

  function hasSavedCookieChoice(){
    if(!privacyApi||typeof privacyApi.currentVisitorConsent!=='function')return false;
    try{
      var consent=privacyApi.currentVisitorConsent()||{};
      return ['analytics','preferences','marketing'].some(function(purpose){
        return consent[purpose]==='yes'||consent[purpose]==='no';
      });
    }catch(error){return false;}
  }

  function syncNotice(){
    if(preview||!privacyApi||!modal.hidden)return;
    try{
      if(privacyApi.shouldShowBanner()&&!hasSavedCookieChoice())showNotice();
      else hideAll();
    }catch(error){
      document.documentElement.classList.remove('nn-custom-privacy-ready');
    }
  }

  function initialize(api){
    privacyApi=api;
    document.documentElement.classList.add('nn-custom-privacy-ready');
    if(preview){showNotice();return;}
    syncNotice();
  }

  window.addEventListener('pageshow',syncNotice);
  document.addEventListener('visitorConsentCollected',syncNotice);

  function loadPrivacyApi(attempt){
    attempt=attempt||0;
    if(window.Shopify&&window.Shopify.customerPrivacy&&typeof window.Shopify.customerPrivacy.setTrackingConsent==='function'){
      initialize(window.Shopify.customerPrivacy);
      return;
    }
    if(window.Shopify&&typeof window.Shopify.loadFeatures==='function'){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
        if(error){
          if(attempt<12)window.setTimeout(function(){loadPrivacyApi(attempt+1);},250);
          return;
        }
        initialize(window.Shopify.customerPrivacy);
      });
      return;
    }
    if(attempt<12)window.setTimeout(function(){loadPrivacyApi(attempt+1);},250);
  }

  loadPrivacyApi();
})();
